"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentProfileReducer = void 0;
var AgentProfileAction_1 = require("@/pages/agentProfile/actions/AgentProfileAction");
var AgentProfileState_init_1 = require("@/pages/agentProfile/states/AgentProfileState.init");
var typesafe_actions_1 = require("typesafe-actions");
exports.agentProfileReducer = function (state, action) {
    if (state === void 0) { state = AgentProfileState_init_1.defaultAgentProfileState; }
    switch (action.type) {
        case typesafe_actions_1.getType(AgentProfileAction_1.default.setBioMore): {
            return __assign(__assign({}, state), { bioMore: action.payload });
        }
        case typesafe_actions_1.getType(AgentProfileAction_1.default.setBioMoreActive): {
            return __assign(__assign({}, state), { bioMoreActive: action.payload });
        }
        case typesafe_actions_1.getType(AgentProfileAction_1.default.setCardMoreActive): {
            return __assign(__assign({}, state), { clientTestimonials: state.clientTestimonials.map(function (it, i) {
                    if (i === action.payload.i)
                        return __assign(__assign({}, it), { active: action.payload.state });
                    return it;
                }) });
        }
        case typesafe_actions_1.getType(AgentProfileAction_1.default.setCardMore): {
            return __assign(__assign({}, state), { clientTestimonials: state.clientTestimonials.map(function (it, i) {
                    if (i === action.payload.i)
                        return __assign(__assign({}, it), { more: action.payload.state });
                    return it;
                }) });
        }
        case typesafe_actions_1.getType(AgentProfileAction_1.default.setPropertiesActive): {
            return __assign(__assign({}, state), { resultTableProperties: state.resultTableProperties.map(function (it) {
                    if (action.payload.indexOf(Number(it.referenceId)) >= 0) {
                        return __assign(__assign({}, it), { isSaved: true });
                    }
                    return __assign(__assign({}, it), { isSaved: false });
                }) });
        }
        case typesafe_actions_1.getType(AgentProfileAction_1.default.onResultTableTypeChanged): {
            return __assign(__assign({}, state), { currentResultTableType: action.payload });
        }
        case typesafe_actions_1.getType(AgentProfileAction_1.default.onTestimonialMoreCardsClick): {
            return __assign(__assign({}, state), { moreLimitActive: true });
        }
        case typesafe_actions_1.getType(AgentProfileAction_1.default.setShowAllProperties): {
            return __assign(__assign({}, state), { showAllProperties: true });
        }
    }
    return state;
};
